export function GetData(type, userData) {

	let BaseURL = 'https://stjosephschool.kalvisalai.in/admin/';

	return new Promise((resolve, reject) => {
		fetch(BaseURL + type, {
			method: 'GET',
			body: JSON.stringify(userData)
		})
			.then((response) => response.json())
			.then((res) => {
				resolve(res);
			})
			.catch((error) => {
				reject(error);
			});
	});
}


// WEBPACK FOOTER //
// ./src/services/GetData.js